import React from "react";
import { motion } from "framer-motion";

// Stylised animated route map: pulsing waypoint nodes connected by drawing arcs.
const NODES = [
  { id: "lisbon", label: "Lisbon", x: 360, y: 150 },
  { id: "dubai", label: "Dubai", x: 560, y: 200 },
  { id: "bangkok", label: "Bangkok", x: 720, y: 235 },
  { id: "singapore", label: "Singapore", x: 760, y: 300 },
  { id: "miami", label: "Miami", x: 200, y: 230 },
  { id: "panama", label: "Panama", x: 235, y: 290 },
];

const ROUTES = [
  ["lisbon", "dubai"],
  ["dubai", "bangkok"],
  ["bangkok", "singapore"],
  ["miami", "lisbon"],
  ["panama", "miami"],
];

function arc(a, b) {
  const mx = (a.x + b.x) / 2;
  const my = Math.min(a.y, b.y) - 60;
  return `M ${a.x} ${a.y} Q ${mx} ${my} ${b.x} ${b.y}`;
}

export function WorldMap({ className = "" }) {
  const byId = Object.fromEntries(NODES.map((n) => [n.id, n]));
  return (
    <svg
      viewBox="0 0 960 440"
      className={className}
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="routeGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#0055FF" />
          <stop offset="100%" stopColor="#D4AF37" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="3" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {ROUTES.map(([a, b], i) => (
        <motion.path
          key={`${a}-${b}`}
          d={arc(byId[a], byId[b])}
          stroke="url(#routeGrad)"
          strokeWidth="1.6"
          strokeLinecap="round"
          filter="url(#glow)"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 0.85 }}
          transition={{ duration: 2, delay: 0.4 + i * 0.45, ease: "easeInOut" }}
        />
      ))}

      {NODES.map((n, i) => (
        <g key={n.id}>
          <circle cx={n.x} cy={n.y} r="9" fill="#0055FF" opacity="0.18" className="node-pulse" />
          <circle cx={n.x} cy={n.y} r="3.2" fill="#D4AF37" filter="url(#glow)" />
          <motion.text
            x={n.x + 10}
            y={n.y + 4}
            fill="rgba(255,255,255,0.6)"
            fontSize="11"
            fontFamily="JetBrains Mono, monospace"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 + i * 0.2 }}
          >
            {n.label}
          </motion.text>
        </g>
      ))}
    </svg>
  );
}

export default WorldMap;
